const baseImageUrl = "https://resources.ebsco.zone/mfe-container/assets/images";
const baseEbscoUrl = "https://www.ebsco.com";
const baseEbscoSupportUrl = "https://connect.ebsco.com";
const baseEbscohostUrl = "https://support.ebscohost.com";
const baseStaticAssetsImageUrl = "https://resources.ebsco.zone/images";

const currentYear = new Date().getFullYear();

const dmp = {
  footerLinks: [
    {
      url: "/editorial-leadership",
      text: "Editorial Leadership",
      target: "_self",
    },
    {
      url: "https://www.ebsco.com/clinical-decisions/dynamed-solutions/dynamed",
      text: "About",
    },
    { url: "/mobile", text: "Mobile" },
    {
      url: "/systemcheck",
      text: "System Check",
      target: "_self",
    },
    {
      url: `${baseEbscoSupportUrl}/s/article/DynaMed-User-Guide`,
      text: "Help",
    },
    {
      url: `${baseEbscohostUrl}/ehost/privacy.html`,
      text: "Privacy Policy",
    },
    {
      url: `https://resources.ebsco.zone/ebsco-policies/terms-of-use.md`,
      text: "Terms of Use",
    },
    {
      url: `${baseEbscohostUrl}/ehost/terms.html#copyright`,
      text: "Copyright",
    },
    {
      url: "",
      text: "Manage Cookies",
      cookiesLink: true,
    },
  ],
  socialLinks: [],
  logo: {
    src: `${baseImageUrl}/ebscoLogo.svg`,
    alt: "DynaMed",
    height: "1rem",
  },
  copyright: {
    text: `© ${currentYear} EBSCO Industries, Inc. All rights reserved.`,
  },
};

const dmx = {
  footerLinks: [
    {
      url: "/editorial-leadership",
      text: "Editorial Leadership",
      target: "_self",
    },
    {
      url: "https://www.ebsco.com/clinical-decisions/dynamed-solutions/dynamed-micromedex-with-watson",
      text: "About",
    },
    { url: "/mobile", text: "Mobile" },
    {
      url: "/systemcheck",
      text: "System Check",
      target: "_self",
    },
    {
      url: `${baseEbscoSupportUrl}/s/article/DynaMedex-User-Guide`,
      text: "Help",
    },
    {
      url: `${baseEbscoUrl}/company/privacy-policy`,
      text: "Privacy Policy",
    },
    {
      url: `https://resources.ebsco.zone/ebsco-policies/terms-of-use.md`,
      text: "Terms of Use",
    },
    {
      url: `${baseEbscohostUrl}/ehost/terms.html#copyright`,
      text: "Copyright",
    },
    {
      url: "",
      text: "Manage Cookies",
      cookiesLink: true,
    },
  ],
  socialLinks: [],
  logo: {
    src: `${baseImageUrl}/DMXFooterLogo.svg`,
    alt: "DynaMedex",
    height: "2rem",
  },
  copyright: {
    text: `© ${currentYear} EBSCO Industries, Inc. All rights reserved.`,
  },
};

const defaultFooter = {
  footerLinks: [
    {
      url: "https://health.ebsco.com/",
      text: "Ebsco Health",
    },
    {
      url: `${baseEbscoUrl}/company/privacy-policy`,
      text: "Privacy Policy",
    },
    {
      url: `${baseEbscohostUrl}/ehost/terms.html#copyright`,
      text: "Copyright",
    },
  ],
  socialLinks: [
    {
      name: "facebook",
      url: "https://www.facebook.com/EBSCOInfoServices",
    },
    {
      name: "twitter",
      url: "https://twitter.com/EBSCO_Health",
    },
    {
      name: "linkedin",
      url: "https://www.linkedin.com/showcase/ebsco-health/",
    },
    {
      name: "youtube",
      url: "https://www.youtube.com/user/ebscopublishing",
    },
    {
      name: "instagram",
      url: "https://www.instagram.com/ebscoinformationservices/",
    },
  ],
  logo: {
    src: `${baseStaticAssetsImageUrl}/EbscoLogo.svg`,
    alt: "Ebsco",
    height: "1rem",
  },
  copyright: {
    text: `© ${currentYear} EBSCO Industries, Inc. All rights reserved.`,
  },
};

export { dmp, dmx, defaultFooter };
